import React from 'react';
export const Footer = () => {
  return <footer className="bg-legal-900 pt-10 pb-8 border-t border-legal-700" data-id="element-64">
      <div className="container mx-auto px-4" data-id="element-65">
        <div className="flex flex-col md:flex-row items-center justify-between text-xs text-slate-500" data-id="element-66">
          <p data-id="element-67">
            &copy; 2026 Tratado Práctico de Defensa del Consumidor. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0" data-id="element-68">
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-69">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-70">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
};